import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField } from '@mui/material';
import { BRD_SDK_VERSION_FILTER_LIST } from '../../config/const.config';

const BRDSDKVERSION = ({
  id,
  name,
  label,
  defaultValue,
  onChange,
  multiple,
  disabled,
  sx,
  error,
}) => {
  const selectedValue = defaultValue || (multiple ? [] : null);
  const options = BRD_SDK_VERSION_FILTER_LIST;

  const [value, setValue] = useState(selectedValue);
  const [inputValue, setInputValue] = useState('');
  return (
    <Autocomplete
      disablePortal
      id={id}
      name={name}
      options={options}
      getOptionLabel={(option) => option.title}
      sx={sx}
      value={value}
      onChange={(e, v) => {
        setValue(v);
        onChange(v);
      }}
      inputValue={inputValue}
      onInputChange={(e, v) => {
        setInputValue(v);
      }}
      multiple={multiple}
      disabled={disabled}
      isOptionEqualToValue={(op, vl) => op.id === vl.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error !== ''}
          helperText={error}
          variant="filled"
        />
      )}
    />
  );
};

BRDSDKVERSION.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
BRDSDKVERSION.defaultProps = {
  multiple: false,
  disabled: false,
  sx: {},
  defaultValue: null,
  error: '',
};

export default BRDSDKVERSION;
